export default {
	props: {
		/**
		 * The label used above the input element.
		 */
		label: { type: String, },
		/**
		 * Wether or not show a asterix after the label.
		 */
		isRequired: { type: Boolean },
		/**
		 * A optional description of the field under the label, above the input element.
		 */
		description: { type: String },
		/**
		 * A optional hint under the input element.
		 */
		hint: { type: String },
		/**
		 * If a validation message is passed it is shown under the input element and above the hint.
		 */
		validationMessage: { type: String },
		/**
		 * Sets visual styling to be invalid.
		 */
		isInvalid: {
			type: Boolean,
			default: false,
		},
		/**
		 * Validation warning message. Displays in orange.
		 */
		warningMessage: { type: String }
	},
};